<template>
  <div class="breadcrumb-container">
    <b-breadcrumb :items="breadcrumbItems" class="custom-breadcrumb">
      <template #text="{ item }">
        <span :class="{ 'breadcrumb-link': item.href, 'breadcrumb-current': !item.href }" @click="item.href ? navigateTo(item.href) : null">
          <i v-if="item.icon" :class="item.icon" class="breadcrumb-icon"></i>
          {{ item.text }}
        </span>
      </template>
    </b-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',

  data() {
    return {
      breadcrumbItems: []
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.generateBreadcrumbs(to)
      }
    }
  },

  methods: {
    generateBreadcrumbs(route) {
      const items = []

      // Sempre adicionar "Início" como primeiro item
      items.push({
        text: 'Início',
        href: '/home',
        icon: 'fas fa-home'
      })

      // Mapear rotas para títulos amigáveis e suas hierarquias
      const routeHierarchy = {
        // Vendas
        SalesList: { text: 'Vendas', parent: null, icon: 'fas fa-shopping-cart' },
        OrderDetails: { text: 'Detalhes do Pedido', parent: 'SalesList', icon: 'fas fa-file-alt' },
        OrderItemsList: { text: 'Itens do Pedido', parent: 'SalesList', icon: 'fas fa-list' },
        OrderPayments: { text: 'Recebimentos', parent: 'SalesList', icon: 'fas fa-wallet' },
        OrderPaymentsDetailed: { text: 'Detalhados', parent: 'OrderPayments', icon: 'fas fa-wallet' },

        // Produtos
        ProdutosList: { text: 'Produtos', parent: null, icon: 'fas fa-box' },
        ProductsSite: { text: 'Produtos do Site', parent: 'ProdutosList', icon: 'fas fa-globe' },

        // Usuários
        UsersList: { text: 'Usuários', parent: null, icon: 'fas fa-users' },
        UsersManager: { text: 'Gerenciar Usuários', parent: 'UsersList', icon: 'fas fa-user-cog' },
        ManagerUserPermissions: { text: 'Permissões', parent: 'UsersList', icon: 'fas fa-key' },

        // Banners
        Banners: { text: 'Banners', parent: null, icon: 'fas fa-images' },
        BannersTotemList: { text: 'Banners Totem', parent: 'Banners', icon: 'fas fa-images' },
        BannersManager: { text: 'Gerenciar Banners', parent: 'BannersTotemList', icon: 'fas fa-edit' },
        BannerAppList: { text: 'Banners App', parent: 'Banners', icon: 'fas fa-mobile-alt' },
        BannerAppManager: { text: 'Gerenciar App', parent: 'BannerAppList', icon: 'fas fa-cog' },

        // Clientes
        CustomerList: { text: 'Clientes', parent: null, icon: 'fas fa-user-tie' },
        CustomersExceptionsList: { text: 'Exceções', parent: 'CustomerList', icon: 'fas fa-exclamation-triangle' },

        // Monitoramento
        Monitoring: { text: 'Monitoramento', parent: null, icon: 'fas fa-desktop' },
        DeviceHistory: { text: 'Histórico de Dispositivos', parent: 'Monitoring', icon: 'fas fa-tablet-alt' },
        EventsHistory: { text: 'Histórico de Eventos', parent: 'Monitoring', icon: 'fas fa-calendar-alt' },

        // Bot
        Bot: { text: 'Bot', parent: null, icon: 'fas fa-robot' },
        BotBound: { text: 'Vincular', parent: 'Bot', icon: 'fas fa-link' },
        BotSpeechs: { text: 'Buscar Fala', parent: 'Bot', icon: 'fas fa-search' },
        BotBounded: { text: 'Fala Vinculada', parent: 'Bot', icon: 'fas fa-check' },

        // Cupons
        DiscountCouponList: { text: 'Cupons', parent: null, icon: 'fas fa-tag' },
        DiscountCouponManager: { text: 'Gerenciar Cupons', parent: 'DiscountCouponList', icon: 'fas fa-edit' },
        DetailsCouponDiscount: { text: 'Detalhes do Cupom', parent: 'DiscountCouponList', icon: 'fas fa-info-circle' },

        // Campanhas
        PushCampaignList: { text: 'Campanhas Push', parent: null, icon: 'fas fa-bullhorn' },
        PushCampaignManager: { text: 'Gerenciar Campanhas', parent: 'PushCampaignList', icon: 'fas fa-edit' },

        // Promoções
        PromotionsList: { text: 'Promoções', parent: null, icon: 'fas fa-percentage' },
        PromotionInfo: { text: 'Informações', parent: 'PromotionsList', icon: 'fas fa-info-circle' },

        // Gateway
        GatewayDocument: { text: 'Gateway', parent: null, icon: 'fas fa-exchange-alt' },
        CustomersRecognitionGateway: { text: 'Reconhecimento', parent: 'GatewayDocument', icon: 'fas fa-fingerprint' },

        // Aplicações
        ApplicationsList: { text: 'Aplicações', parent: null, icon: 'fas fa-mobile-alt' },
        ValidateAppCode: { text: 'Validar Código', parent: 'ApplicationsList', icon: 'fas fa-check-circle' },

        // Estoque
        StockBacklogs: { text: 'Estoque', parent: null, icon: 'fas fa-warehouse' },
        StockAdjustmentDocuments: { text: 'Ajuste - Documentos', parent: 'StockBacklogs', icon: 'fas fa-file-alt' },
        DetailsItemsDocuments: { text: 'Detalhes de Itens', parent: 'StockBacklogs', icon: 'fas fa-list' },
        StockAdjustmentItemsDocuments: { text: 'Ajuste - Itens', parent: 'StockBacklogs', icon: 'fas fa-boxes' },

        // Dispositivos
        DevicesList: { text: 'Dispositivos', parent: null, icon: 'fas fa-tablet-alt' },
        DevicesEdit: { text: 'Editar', parent: 'DevicesList', icon: 'fas fa-edit' },

        // Outros
        Setup: { text: 'Configurações', parent: null, icon: 'fas fa-cog' },
        Tokens: { text: 'Tokens', parent: null, icon: 'fas fa-key' },

        // Home
        HomeView: { text: 'Dashboard', parent: null, icon: 'fas fa-tachometer-alt' }
      }

      // Gerar breadcrumbs hierárquicos baseado na rota atual
      if (route.name && route.name !== 'Início') {
        const routeName = route.name

        // Se a rota tem hierarquia definida, construir o breadcrumb completo
        if (routeHierarchy[routeName]) {
          const hierarchy = this.buildHierarchy(routeName, routeHierarchy)
          hierarchy.forEach(item => {
            items.push({
              text: item.text,
              href: item.href,
              icon: item.icon
            })
          })
        } else {
          // Fallback para rotas não mapeadas
          const title = this.formatRouteName(routeName)
          items.push({
            text: title,
            href: null,
            icon: this.getIconForRoute(routeName)
          })
        }
      }

      this.breadcrumbItems = items
    },

    buildHierarchy(routeName, routeHierarchy) {
      const hierarchy = []
      let currentRoute = routeName

      // Construir hierarquia de baixo para cima
      while (currentRoute && routeHierarchy[currentRoute]) {
        const routeInfo = routeHierarchy[currentRoute]
        hierarchy.unshift({
          text: routeInfo.text,
          href: this.getHrefForRoute(currentRoute),
          icon: routeInfo.icon
        })
        currentRoute = routeInfo.parent
      }

      return hierarchy
    },

    getHrefForRoute(routeName) {
      // Mapear nomes de rotas para seus caminhos
      const routePaths = {
        SalesList: '/orders-list',
        OrderDetails: '/order-details',
        OrderItemsList: '/order-items-list',
        OrderPayments: '/order-payments',
        OrderPaymentsDetailed: '/order-payments-detailed',
        ProdutosList: '/products-list',
        ProductsSite: '/products-site',
        UsersList: '/users-list',
        UsersManager: '/users-manager',
        ManagerUserPermissions: '/manager-user-permissions',
        BannersTotemList: '/banners-totem-list',
        BannersManager: '/banners-manager',
        BannerAppList: '/banners-app-list',
        BannerAppManager: '/banners-app-manager',
        CustomerList: '/customer-list',
        CustomersExceptionsList: '/customers-exceptions-list',
        Monitoring: '/monitoring-pos',
        DeviceHistory: '/device-history',
        EventsHistory: '/events-history',
        Bot: '/bot',
        BotBound: '/bot-bound',
        BotSpeechs: '/bot-speechs',
        BotBounded: '/bot-bounded',
        DiscountCouponList: '/discount-coupon-list',
        DiscountCouponManager: '/discount-coupon-manager',
        DetailsCouponDiscount: '/details-coupon-discount',
        PushCampaignList: '/push-campaign-list',
        PushCampaignManager: '/push-campaign-manager',
        PromotionsList: '/promotions',
        PromotionInfo: '/promotion-info',
        GatewayDocument: '/gateway-documents',
        CustomersRecognitionGateway: '/gateway-recognition',
        ApplicationsList: '/applications',
        ValidateAppCode: '/validate-app-code',
        StockBacklogs: '/stock-backlogs',
        StockAdjustmentDocuments: '/stock-adjustment-documents',
        DetailsItemsDocuments: '/details-items-documents',
        StockAdjustmentItemsDocuments: '/stock-adjustment-items-documents',
        DevicesList: '/devices-list',
        DevicesEdit: '/devices',
        Setup: '/setup',
        Tokens: '/tokens',

        HomeView: '/home'
      }

      return routePaths[routeName] || null
    },

    formatRouteName(routeName) {
      // Converter camelCase para texto legível
      return routeName
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim()
    },

    getIconForRoute(routeName) {
      // Mapear ícones para diferentes tipos de rotas
      const iconMap = {
        home: 'fas fa-tachometer-alt',
        products: 'fas fa-box',
        users: 'fas fa-users',
        banners: 'fas fa-images',
        setup: 'fas fa-cog',
        customer: 'fas fa-user-tie',
        orders: 'fas fa-shopping-cart',
        monitoring: 'fas fa-desktop',
        bot: 'fas fa-robot',
        discount: 'fas fa-tag',
        push: 'fas fa-bullhorn',
        promotions: 'fas fa-percentage',
        gateway: 'fas fa-exchange-alt',
        tokens: 'fas fa-key',
        applications: 'fas fa-mobile-alt',
        stock: 'fas fa-warehouse',
        device: 'fas fa-tablet-alt',
        events: 'fas fa-calendar-alt'
      }

      // Encontrar o ícone baseado no nome da rota
      for (const [key, icon] of Object.entries(iconMap)) {
        if (routeName.toLowerCase().includes(key)) {
          return icon
        }
      }

      return 'fas fa-chevron-right' // Ícone padrão
    },

    navigateTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb-container {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}

.custom-breadcrumb {
  margin-bottom: 0;
  background: transparent;
  padding: 0;

  ::v-deep .breadcrumb-item {
    font-size: 0.9rem;

    &:not(:last-child)::after {
      content: '>';
      color: #6c757d;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }
}

.breadcrumb-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
}

.breadcrumb-current {
  color: #495057;
  font-weight: 500;
}

.breadcrumb-icon {
  margin-right: 0.5rem;
  width: 14px;
  text-align: center;
}

// Responsividade
@media (max-width: 768px) {
  .breadcrumb-container {
    padding: 0.5rem;
  }

  .custom-breadcrumb {
    ::v-deep .breadcrumb-item {
      font-size: 0.8rem;
    }
  }

  .breadcrumb-icon {
    display: none; // Ocultar ícones em mobile para economizar espaço
  }
}
</style>
